import {$divaltoAgencies} from '@/services/'

const module = {
    namespaced: true,

    state: {
        items: [],
        item: {},
        meta: { pagination: {}}
    },

    getters: {
        items: state => state.items,
        item: state => state.item,
        meta: state => state.meta
    },

    mutations: {
        ITEMS(state, value){
            state.items = value
        },

        ITEM(state,value){
            state.item = value
        },

        ADD_ITEM(state, value){
            state.items.push(value)
        },

        META(state, meta){
            state.meta = meta
        },
    },

    actions: {
        all({commit}, {config}){
            return $divaltoAgencies.all(config).then(function(res){
                let {data, meta} = res.data
                commit('ITEMS', data)
                commit('META', meta)
                return res.data
            }).catch(function(error){
                this.debug('[client.store/actions/all]::Error', error)
            })
        },
        find({ commit }, { id, config }){
          return $divaltoAgencies.show(id, config)
          .then(res => {
            commit('ITEM', res.data.data)
            return res.data.data
          })
        },
    }
}

export default module
